import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { useCurrentScope } from '../../../shared/scope/useCurrentScope.js';
import {
  getTelegramOutboundSettings,
  patchTelegramOutboundSubscription,
  telegramOutboundQueryKey,
  type UpdateTelegramOutboundSubscription,
} from '../api/telegram-outbound.client.js';

export function useTelegramOutboundSettings() {
  const scope = useCurrentScope();
  return useQuery({
    queryKey: telegramOutboundQueryKey(scope?.workspaceId ?? 'anonymous'),
    queryFn: getTelegramOutboundSettings,
    enabled: scope !== null,
  });
}

export function useTelegramOutboundMutation() {
  const scope = useCurrentScope();
  const client = useQueryClient();
  const key = telegramOutboundQueryKey(scope?.workspaceId ?? 'anonymous');
  return useMutation({
    mutationFn: (input: UpdateTelegramOutboundSubscription) =>
      patchTelegramOutboundSubscription(input),
    onSuccess: async (data) => {
      client.setQueryData(key, data);
      await client.invalidateQueries({ queryKey: key });
    },
  });
}
